import axios from "axios"

import { appConfig } from "@/config/app-config"

export const apiService = axios.create({
  baseURL: appConfig.apiBaseUrl,
})
